import { CombinedGraphQLErrors } from '@apollo/client'

import { Cookie } from '../cookie'

// expire user & admin sessions after 3 hours of inactivity
const SESSION_TIMEOUT_MS = 3 * 60 * 60 * 1000

let timeoutId: ReturnType<typeof setTimeout> | null = null

export const sessionExpiredMessage = 'Your session has expired. Please sign in again.'

const authError = 'Authentication is required'

/**
 * The server signals an expired session with a GraphQL error, which Apollo
 * Client 4 delivers as `CombinedGraphQLErrors` rather than v3's
 * `ApolloError.graphQLErrors`. Lives here rather than in `apollo-client.ts` so
 * it is testable without booting a client and a Phoenix socket.
 */
export const isSessionExpiredError = (error: unknown) =>
  CombinedGraphQLErrors.is(error) &&
  error.errors.some((e) => e.message === authError)

export const shouldRedirectToLogin = (error: unknown) =>
  !isAuthPage() && isSessionExpiredError(error)

export const loginUrlWithExpiredMessage = () =>
  `/login/email?message=${encodeURIComponent(sessionExpiredMessage)}`

export const isAuthPage = () =>
  window.location.pathname.startsWith('/login') ||
  window.location.pathname.startsWith('/signin') ||
  window.location.pathname.startsWith('/signup') ||
  window.location.pathname.startsWith('/register') ||
  window.location.pathname.startsWith('/forgot-password') ||
  window.location.pathname.startsWith('/reset-password')

export function resetSessionTimer() {
  if (timeoutId) clearTimeout(timeoutId)

  timeoutId = setTimeout(() => {
    if (!isAuthPage()) {
      // clean up cookies as the user session has expired
      Cookie.delete('redirectTo')
      Cookie.delete('giftInProgress')

      window.location.href = loginUrlWithExpiredMessage()
    }
  }, SESSION_TIMEOUT_MS)
}

export function clearSessionTimer() {
  if (timeoutId) {
    clearTimeout(timeoutId)
    timeoutId = null
  }
}
